import { StorageKeys } from '@/types/common';

export const STORAGE_KEYS: StorageKeys = {
  USER_SESSION: 'orb_user_session',
  REFRESH_TOKEN: 'orb_refresh_token',
  SELECTED_ORGANIZATION: 'orb_selected_organization',
  SELECTED_VENUE: 'orb_selected_venue',
  SELECTED_STORE: 'orb_selected_store',
  AUTH_TOKENS: 'orb_auth_tokens',
  FINGERPRINT_UUID: 'orb_fingerprint_uuid',
};
